import 'react-quill/dist/quill.snow.css'
import React from 'react'
import { Row, Col, FormGroup, Button } from 'reactstrap'
import { I18n } from 'react-redux-i18n'
import ReactQuill from 'react-quill'
import { quillModules } from 'utils'

const ChatInputText = ({ onChangeComment, sendComment }) => {
  return (
    <FormGroup className={'mb-1'}>
      <Row>
        <Col>
          <ReactQuill
            onChange={onChangeComment}
            className='form-control'
            placeholder={I18n.t('write_comment_placeholder')}
            modules={quillModules.modulesComment}
            formats={quillModules.formatsComment}
          />
        </Col>
      </Row>
      <Row>
        <Col className='text-right'>
          <Button onClick={sendComment} className='mt-0' size='sm' color='link'>
            {I18n.t('dashboard_send')}
          </Button>
        </Col>
      </Row>
    </FormGroup>
  )
}

export default ChatInputText
